export const COOKIE_SELECTION = 'COOKIE_SELECTION';

export const cookieSelection = cookieChoice => ({
  type: COOKIE_SELECTION,
  cookieChoice,
});
